(() => {
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const menuButton = document.querySelector('[data-menu-toggle]');
  const menu = document.querySelector('[data-mobile-menu]');
  menuButton?.addEventListener('click', () => {
    const open = menuButton.getAttribute('aria-expanded') === 'true';
    menuButton.setAttribute('aria-expanded', String(!open));
    menu.hidden = open;
  });

  document.querySelectorAll('[data-product-form]').forEach(form => {
    const select = form.querySelector('[name="id"]');
    const price = form.querySelector('[data-product-price]');
    const button = form.querySelector('[name="add"]');
    select?.addEventListener('change', () => {
      const option = select.selectedOptions[0];
      if (price && option.dataset.price) price.textContent = option.dataset.price;
      const available = option.dataset.available === 'true';
      if (button) {
        button.disabled = !available;
        button.textContent = available ? button.dataset.addLabel : button.dataset.soldLabel;
      }
      const url = new URL(location.href);
      url.searchParams.set('variant', option.value);
      history.replaceState({}, '', url);
    });
  });

  const magic = document.querySelector('[data-magic-text]');
  if (magic) {
    const words = magic.textContent.trim().split(/\s+/);
    magic.textContent = '';
    words.forEach(word => {
      const span = document.createElement('span');
      span.className = 'magic-word';
      span.textContent = word;
      magic.append(span, document.createTextNode(' '));
    });
    if (reduce) {
      magic.querySelectorAll('.magic-word').forEach(word => word.classList.add('is-lit'));
    } else {
      const update = () => {
        const rect = magic.closest('.about-belief').getBoundingClientRect();
        const progress = Math.max(0, Math.min(1, (innerHeight * .75 - rect.top) / (rect.height + innerHeight * .35)));
        const all = [...magic.querySelectorAll('.magic-word')];
        all.forEach((word, index) => word.classList.toggle('is-lit', index / all.length <= progress));
      };
      addEventListener('scroll', update, {passive:true});
      update();
    }
  }

  if (!reduce) {
    const items = document.querySelectorAll('[data-reveal]');
    const observer = new IntersectionObserver(entries => entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    }), {threshold:.12,rootMargin:'0px 0px -8% 0px'});
    items.forEach(item => observer.observe(item));
  } else {
    document.querySelectorAll('[data-reveal]').forEach(item => item.classList.add('is-visible'));
  }
})();
